import { render, staticRenderFns } from "./creatComment.vue?vue&type=template&id=7b049653&scoped=true"
import script from "./creatComment.vue?vue&type=script&lang=js"
export * from "./creatComment.vue?vue&type=script&lang=js"
import style0 from "./creatComment.vue?vue&type=style&index=0&id=7b049653&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b049653",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\XM\\QD\\yangzhou\\merchant-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7b049653')) {
      api.createRecord('7b049653', component.options)
    } else {
      api.reload('7b049653', component.options)
    }
    module.hot.accept("./creatComment.vue?vue&type=template&id=7b049653&scoped=true", function () {
      api.rerender('7b049653', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/scenic-spot/comment/creatComment.vue"
export default component.exports